module.exports = __webpack_public_path__ + "img/bgsh.fb4ec21b.png";